module.exports = __webpack_public_path__ + "static/media/cv.9a8d2f74.png";